import { get, post } from '../utils/request';

export function walletLogin(data) {
  return post('/web/wallet_login', data);
}

export function getUser() {
  return post('/v1/chain/get_user', {}, true);
}

export function addAddress(data) {
  return post('/v1/chain/add_address', data, true);
}

export function deleteAddress(data) {
  return post('/v1/chain/delete_address', data, true);
}

export function getAssets() {
  return post('/v1/chain/get_assets', {}, true);
}

export function getValuableArticleList(data) {
  return post('/v1/chain/get_valuable_article_list', data);
}
export function getValuableArticleListAuth(data) {
  return post('/v1/chain/get_valuable_article_list', data, true);
}

export function getValuableArticleDetail(data) {
  return post('/v1/chain/get_valuable_article_detail', data);
}
export function getValuableArticleDetailAuth(data) {
  return post('/v1/chain/get_valuable_article_detail', data, true);
}
export function getPoint() {
  return get('/v1/user/get_point', {}, true);
}
export function getReceiveData() {
  return post('/v1/honor/get_receive_data', {}, true);
}
export function receiveAward(data) {
  return post('/v1/honor/receive_award', data, true);
}
export function mintDeadline(data) {
  return post('/v1/zk_era/mint_deadline', data, true);
}
export function getOneOwnedName(data) {
  return post('/v1/zk_era/get_one_owned_name', data, true);
}
